import React, { useContext, useMemo } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme, alpha } from '@material-ui/core/styles';

import { Drawer, AppBar, Toolbar, List, Divider, ListItem, ListItemText, Collapse, Grid, MenuItem, MenuList, Popover } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Link, NavLink, Route, Switch } from 'react-router-dom';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { useWindowSize } from '../Controls/ScreenResolution';
import AppContext from '../../App/AppContext';
import { getMenuForRole } from './_menu';
import MySignature from '../Modal/SignatureModal';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AdminIcon from '@material-ui/icons/SupervisorAccount';
import { postSignature, postSignatureStatus } from '../Service/login-service';
import { AppStorage } from '../Service/storage-service';
import TemporaryDrawer from './Drawer';
const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& .MuiTypography-body1': {
            fontSize: '0.8rem',
            fontFamily: 'Montserrat !important',
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: '0.00938em'
        }
    },
    appBar: {
        height: '60px',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    appBarShift: {
        marginLeft: (props) => (props.WindowWidths < 900 ? 0 : drawerWidth),
        width: (props) => (props.WindowWidths < 900 ? '100%' : `calc(100% - 301px)`),
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    menuButton: {
        marginRight: 36
    },
    hide: {
        display: 'none'
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap'
    },
    drawerOpen: {
        background: (props) => `${props.portalMenuBarBackgroundColour}`,
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerClose: {
        background: (props) => `${props.portalMenuBarBackgroundColour}`,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: 'hidden',
        //width: theme.spacing(6.5) + 1,
        width: '100px',
        [theme.breakpoints.up('sm')]: {
            //width: theme.spacing(6.5) + 1
        }
    },
    toolbar: {
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(6.5) + 1
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar
    },
    app_toolbar: {
        height: '60px',
        minHeight: '60px',
        display: 'flex',
        padding: '0px'
    },
    drawerPaper: {
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            outline: '1px solid slategrey'
        }
    },

    labelBtn: {
        color: '#569101',
        textTransform: 'none',
        textDecoration: 'none',
        fontSize: '16px',
        fontFamily: 'Montserrat'
    },
    menuIcon: {
        minWidth: '40px'
    },
    logoutBtn: {
        display: 'inline-flex',
        VerticalAlign: 'text-bottom',
        BoxSizing: 'inherit',
        textAlign: 'center',
        alignItems: 'center',
        textDecoration: 'none',
        cursor: 'pointer',
        marginLeft: 1
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25)
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        marginTop: (props) => (props.WindowWidths > 750 ? 4 : 0),
        width: '180px !important',
        maxHeight: '30px',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto'
        }
    },
    searchIcon: {
        padding: theme.spacing(0, 0.9),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    inputRoot: {
        color: 'inherit'
    },
    inputInput: {
        padding: '4px 8px 8px 0px',
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch'
        }
    },
    linknav: {
        background: (props) => `${props.portalMenuBarBackgroundColour}`,
        fontFamily: 'Montserrat',
        textDecoration: 'none',
        color: (props) => `${props.portalMenuBarTextColour}`,
        fontSize: '15px',
        '&:hover': {
            backgroundColor: '#4b573b'
        }
    },
    activeLink: {
        '& .MuiButtonBase-root': {
            backgroundColor: '#4b573b',
        },
        '& .MuiTypography-root': {
            color: '#DAFFA7 !important'
        }
    },
    itemText: {
        color: (props) => `${props.portalMenuBarTextColour}`,
        '& span, & svg': {
            fontSize: '0.875rem',
            color: (props) => `${props.portalMenuBarTextColour}`
        }
    },
    ChevronRightIconBtn: {
        color: (props) => `${props.portalMenuBarTextColour}`
    },
    LogInColour: {
        backgroundColor: (props) => `${props.portalHeaderBackgroundColour}`,
        color: (props) => `${props.portalHeaderTextColour}`,
        boxShadow: 'none',
    },
    LogOutColour: {
        display: 'none'
    }
}));

export default function MiniDrawer(props) {
    const { loggedIn, userRoles, displayName, showToast, portalSettings, showModal, tempMenus } = useContext(AppContext);
    const [WindowWidths] = useWindowSize();
    const classes = useStyles({ ...portalSettings, WindowWidths });
    const theme = useTheme();
    const [open, setOpen] = React.useState((localStorage.getItem('_sideBarIsOpen_') || '').toUpperCase() === 'TRUE' || false);
    const [state, setState] = React.useState({
        isError404: false,
        WorkflowJobs: []
    });
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openSign, setOpenSign] = React.useState(false);
    const [adminDashboardText, setAdminDashboardText] = React.useState(localStorage.getItem('_adminNavigationText_') || 'Admin')


    let isAdmin = userRoles.includes('admin');

    const currentMenus = useMemo(() => {
        let menus = getMenuForRole(userRoles, loggedIn);

        return menus;
    }, [loggedIn, tempMenus]);

    const handleDrawerOpen = (isFlag) => {
        if (isFlag == true) {
            localStorage.setItem('_sideBarIsOpen_', true);
        }
        setOpen(true);
    };

    const handleDrawerClose = (isFlag) => {
        if (isFlag == true) {
            localStorage.setItem('_sideBarIsOpen_', false);
        }

        setOpen(false);
    };

    const handleClick = (item) => {
        setState((st) => ({ ...st, [item]: !st[item] }));
        handleDrawerOpen();
    };

    const handler = (children, isFiltered, isIcon) => {
        let currentNav = children;
        return currentNav?.map((subOption, index) => {
            if (!subOption.children) {
                return (
                    <div key={subOption.label}>
                        <NavLink activeClassName={classes.activeLink} exact to={subOption.path} className={classes.linknav}>
                            <ListItem className={classes.linknav} button size="small" key={subOption.label} title={subOption.label} onClick={handleDrawerClose}>
                                {isIcon ? (
                                    <ListItemIcon style={{ color: portalSettings.portalMenuBarTextColour }} className={classes.menuIcon}>
                                        {subOption.icon}
                                    </ListItemIcon>
                                ) : (
                                    ''
                                )}
                                {!open && !isIcon ? <div className={classes.menuIcon}></div> : ''}
                                <ListItemText className={classes.itemText}>{subOption.label}</ListItemText>
                            </ListItem>
                        </NavLink>
                    </div>
                );
            }
            return (
                <div key={subOption.label}>
                    <ListItem className={classes.linknav} button onClick={() => handleClick(subOption.label)} title={subOption.label}>
                        {isIcon ? (
                            <ListItemIcon style={{ color: portalSettings.portalMenuBarTextColour }} className={classes.menuIcon}>
                                {subOption.icon}
                            </ListItemIcon>
                        ) : (
                            ''
                        )}
                        {!open && !isIcon ? <div className={classes.menuIcon}></div> : ''}
                        <ListItemText className={classes.itemText}>{subOption.label}</ListItemText>
                        <ListItemIcon
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                minWidth: '35px'
                            }}
                            className={classes.linknav}
                        >
                            {state[subOption.label] ? <ExpandLess /> : <ExpandMore />}
                        </ListItemIcon>
                    </ListItem>
                    <Collapse className={classes.nested} in={state[subOption.label]} timeout="auto" unmountOnExit>
                        {handler(subOption.children, true, false)}
                    </Collapse>
                </div>
            );
        });
    };
    const openInfo = Boolean(anchorEl);
    const id = openInfo ? 'simple-popover' : undefined;
    const handlePopupClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handlePopupClose = () => {
        setAnchorEl(null);
    };

    const closeSign = () => {
        setOpenSign(!openSign);
    };

    const AdminDashboardHandle = () => {
        if (adminDashboardText == 'Admin') {
            setAdminDashboardText('User');
            localStorage.setItem('_adminNavigationText_', 'User');
            localStorage.setItem('_adminUserDashboard_', 'admin');
            window.location = '/';
        }
        else {
            setAdminDashboardText('Admin');
            localStorage.setItem('_adminNavigationText_', 'Admin');
            localStorage.setItem('_adminUserDashboard_', 'user');
            window.location = '/';
        }
    }

    const showPasswordChangeModal = (e) => {
        e.preventDefault();
        showModal('PasswordChange');
    };

    const postSignData = async (sign, id) => {
        const data = {
            signature: sign
        };
        let resSign = sign && (await postSignature(data));

        if (resSign) {
            if (resSign?.success) {
                AppStorage.setSignature(sign);
                showToast('Signature Updated Successfully!');
            } else {
                showToast(resSign?.message || 'Something went wrong!');
            }
        }
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    const absoluteClass = {
        position: WindowWidths > 900 ? "absolute" : "",
        zIndex: '1300'
    }

    const loggedInStyle = {
        paddingLeft: loggedIn && WindowWidths > 900 ? '100px' : ''
    }

    const menuIconOpenClose = !open ? 
    <>
        <svg width="30" height="22" viewBox="0 0 37 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Expand-02 1">
                <g id="Group">
                    <path id="Vector" d="M29.1851 11.1201C28.5003 10.443 27.7752 9.78648 27.1105 9.08891C26.1437 8.08359 26.0632 7.03724 26.8688 6.19605C27.6745 5.35487 28.742 5.3959 29.7088 6.36019C31.5014 8.16566 33.294 9.97113 35.0463 11.7971C35.9929 12.7819 36.0131 13.7667 35.0664 14.7515C33.2738 16.598 31.4812 18.4445 29.6484 20.2705C28.7218 21.1938 27.6745 21.1938 26.889 20.3936C26.1034 19.5935 26.1236 18.5266 27.03 17.5828C27.7148 16.8442 28.46 16.1672 29.3664 15.285C28.742 15.2644 28.3996 15.2234 28.037 15.2234C20.1818 15.2234 12.3266 15.2234 4.47143 15.2234C2.71912 15.2234 1.7926 14.5669 1.77246 13.3153C1.75232 12.0843 2.71912 11.3868 4.43115 11.3868C12.2863 11.3868 20.1415 11.3868 27.9967 11.3868C28.3392 11.3868 28.7017 11.3868 29.0441 11.3868C29.0844 11.2842 29.1448 11.2021 29.1851 11.1201Z" fill="white" fillOpacity="1"/>
                    <path id="Vector_2" d="M12.1252 7.46807C9.40609 7.46807 6.68698 7.46807 3.96787 7.46807C2.61839 7.46807 1.79259 6.74998 1.77245 5.62156C1.7523 4.45211 2.59825 3.69299 4.00816 3.69299C9.44637 3.69299 14.8846 3.693 20.3228 3.693C21.6924 3.693 22.4779 4.37005 22.4981 5.5395C22.5182 6.74999 21.7126 7.44755 20.2825 7.44755C17.5634 7.46807 14.8443 7.46807 12.1252 7.46807Z" fill="white" fillOpacity="1"/>
                    <path id="Vector_3" d="M12.1051 19.101C14.8645 19.101 17.6037 19.101 20.3631 19.101C21.7126 19.101 22.4981 19.8191 22.4981 20.9886C22.478 22.158 21.6924 22.8556 20.343 22.8556C14.8645 22.8556 9.4061 22.8556 3.9276 22.8556C2.59826 22.8556 1.77246 22.0965 1.77246 20.9475C1.77246 19.8191 2.61841 19.101 3.94775 19.0805C6.66685 19.101 9.38596 19.101 12.1051 19.101Z" fill="white" fillOpacity="1"/>
                </g>
            </g>
        </svg>
    </> : 
    <>
        <svg width="30" height="22" viewBox="0 0 37 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Group">
                <path id="Vector" d="M6.58126 13.5463C7.26607 14.3278 7.99116 15.0857 8.65584 15.8909C9.62263 17.0513 9.7032 18.2591 8.89754 19.2301C8.09188 20.2011 7.02437 20.1537 6.05758 19.0407C4.26498 16.9566 2.47238 14.8725 0.720069 12.7648C-0.226582 11.628 -0.246728 10.4913 0.699928 9.35452C2.49252 7.22309 4.28512 5.09167 6.118 2.98393C7.04451 1.91822 8.09187 1.91822 8.87739 2.84183C9.66291 3.76545 9.64277 4.99694 8.7364 6.08634C8.05159 6.9389 7.30635 7.72043 6.39998 8.73877C7.02437 8.76246 7.36678 8.80982 7.72933 8.80982C15.5845 8.80982 23.4397 8.80982 31.2949 8.80982C33.0472 8.80982 33.9738 9.56766 33.9939 11.0123C34.014 12.4332 33.0472 13.2384 31.3352 13.2384C23.48 13.2384 15.6248 13.2384 7.76961 13.2384C7.4272 13.2384 7.06465 13.2384 6.72225 13.2384C6.68196 13.3569 6.62154 13.4516 6.58126 13.5463Z" fill="white" fillOpacity="1"/>
                <path id="Vector_2" d="M23.6412 17.7618C26.3603 17.7618 29.0794 17.7618 31.7985 17.7618C33.148 17.7618 33.9738 18.5907 33.9939 19.8932C34.0141 21.2431 33.1681 22.1194 31.7582 22.1194C26.32 22.1194 20.8818 22.1194 15.4436 22.1194C14.0739 22.1194 13.2884 21.3379 13.2683 19.988C13.2481 18.5907 14.0538 17.7855 15.4838 17.7855C18.2029 17.7618 20.9221 17.7618 23.6412 17.7618Z" fill="white" fillOpacity="1"/>
                <path id="Vector_3" d="M23.6613 4.33386C20.9019 4.33386 18.1627 4.33386 15.4033 4.33386C14.0538 4.33386 13.2683 3.50498 13.2683 2.15507C13.2884 0.805172 14.0739 -3.29656e-05 15.4234 -3.31228e-05C20.9019 -3.37609e-05 26.3603 -3.43968e-05 31.8388 -3.50349e-05C33.1681 -3.51898e-05 33.9939 0.876218 33.9939 2.20244C33.9939 3.50497 33.148 4.33386 31.8186 4.35754C29.0995 4.33386 26.3804 4.33386 23.6613 4.33386Z" fill="white" fillOpacity="1"/>
            </g>
        </svg>
    </>;

    const logoImgOpen = !!portalSettings.portalSettingMainLogo ? portalSettings.portalSettingMainLogo : `${process.env.PUBLIC_URL}/${portalSettings.portalSettingLogo}`;

    const logoImgClose = "data:image/png;base64,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";

    const logoImg = open ? logoImgOpen :logoImgClose;
    
    return (
        <div className={classes.root}>
            <AppBar
                position="fixed"
                className={`ScaleResizerClass appBar-height ${clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                    [classes.LogInColour]: loggedIn,
                    [classes.LogOutColour]: !loggedIn
                })}`}
                style={WindowWidths < 900 ? {padding: '0 15px'} : {padding: '0'} }
            >
                <Toolbar className={classes.app_toolbar}>
                    <Grid container justifyContent="space-between">
                        <Grid item>
                            {loggedIn && (
                                <>
                                    {WindowWidths > 900 ? (
                                        ""
                                        // <IconButton
                                        //     color="inherit"
                                        //     aria-label="open drawer"
                                        //     onClick={() => handleDrawerOpen(true)}
                                        //     edge="start"
                                        //     style={{ padding: '0px', marginLeft: '7px' }}
                                        //     className={clsx(classes.menuButton, {
                                        //         [classes.hide]: open
                                        //     })}
                                        // >
                                        //     <MenuIcon />
                                        // </IconButton>
                                    ) : (
                                        <IconButton
                                            onClick={toggleDrawer('left', true)}
                                            edge="start"
                                            className={classes.menuButton}
                                            color="inherit"
                                            aria-label="menu"
                                        >
                                            <MenuIcon />
                                        </IconButton>
                                    )}
                                </>
                            )}
                        </Grid>
                        <Grid item style={{ flex: 1 }}>
                            <Grid container justifyContent="space-between" alignItems="center" style={{height: 100+'%'}}>
                                <Grid item></Grid>
                                <Grid item>
                                    <div style={{ display: 'inline-block', paddingLeft: 15 }}>
                                        {loggedIn ? (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Grid
                                                    style={{
                                                        marginRight: 2,
                                                        display: 'inline-flex',
                                                        marginTop: -7
                                                    }}
                                                ></Grid>
                                                &nbsp;
                                                <Grid
                                                    container
                                                    aria-describedby={id}
                                                    onClick={handlePopupClick}
                                                    className={classes.logoutBtn}
                                                    alignItems="center"
                                                >
                                                    <Grid item>
                                                        <span className={classes.labelBtn}>{displayName}</span>
                                                    </Grid>
                                                    <Grid item>
                                                        <ExpandMore />
                                                    </Grid>
                                                </Grid>
                                                <Popover
                                                    id={id}
                                                    open={openInfo}
                                                    anchorEl={anchorEl}
                                                    onClose={handlePopupClose}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center'
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'center'
                                                    }}
                                                >
                                                    <MenuList style={{}}>
                                                        <MenuItem>
                                                            <Link to="/logout" className={`${classes.logoutBtn} ${classes.labelBtn}`}>
                                                                <ExitToAppIcon style={{ marginRight: 4+'px' }} />
                                                                <span>Logout</span>
                                                            </Link>
                                                        </MenuItem>
                                                        {!isAdmin && (
                                                            <MenuItem className={classes.labelBtn} onClick={closeSign}>
                                                                <BorderColorIcon style={{ marginRight: 4+'px' }} />
                                                                <span onClick={closeSign}>My Signature</span>
                                                            </MenuItem>
                                                        )}
                                                        <MenuItem className={classes.labelBtn}>
                                                            <VpnKeyIcon style={{ marginRight: 4+'px' }} />
                                                            <span onClick={showPasswordChangeModal}>Change Password</span>
                                                        </MenuItem>
                                                        {isAdmin && (
                                                            <MenuItem className={classes.labelBtn} onClick={AdminDashboardHandle}>
                                                                <AdminIcon style={{ marginRight: 4+'px' }} />
                                                                <span onClick={AdminDashboardHandle}>{adminDashboardText} Dashboard</span>
                                                            </MenuItem>
                                                        )}
                                                        <MenuItem className={classes.labelBtn} style={{ cursor: 'none' }}>
                                                            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                                            <span>Version 2.0</span>
                                                        </MenuItem>
                                                    </MenuList>
                                                </Popover>
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>

            {openSign && <MySignature onClose={closeSign} postData={postSignData} />}
            {loggedIn && (
                <div className="ScaleResizerClass" style={absoluteClass}>
                    {WindowWidths > 900 ? (
                        <Drawer
                            variant="permanent"
                            className={clsx(classes.drawer, {
                                [classes.drawerOpen]: open,
                                [classes.drawerClose]: !open
                            }, open ? "open-left-nav" : "close-left-nav")}
                            classes={{
                                paper: clsx({
                                    [classes.drawerOpen]: open,
                                    [classes.drawerClose]: !open
                                })
                            }}
                            PaperProps={{ className: `appBar-height ${classes.drawerPaper}` }}
                        >
                            <div className={open ? "logoImgWrp open" : "logoImgWrp"}>
                                <img src={logoImg} className="logoImg" alt="NICOL" />
                            </div>

                            <div className={classes.toolbar}  style={{ minHeight: 60+'px', justifyContent: 'flex-start', paddingLeft: 0 }}>
                                <IconButton onClick={() => open ? handleDrawerClose(true) : handleDrawerOpen(true)} className={classes.ChevronRightIconBtn}>
                                    {menuIconOpenClose}
                                </IconButton>
                            </div>
                            <Divider />
                            <List>
                                {handler(
                                    currentMenus.filter((m) => !m.hidden),
                                    false,
                                    true
                                )}
                            </List>
                        </Drawer>
                    ) : (
                        <Drawer
                            anchor={'left'}
                            open={state.left}
                            onClose={toggleDrawer('left', false)}
                            PaperProps={{ className: `appBar-height ${classes.drawerPaper}` }}
                            BackdropProps={{ className: `appBar-height` }}
                        >
                            <TemporaryDrawer currentMenus={currentMenus} onClose={toggleDrawer} />
                        </Drawer>
                    )}
                </div>
            )}
            <main className="content" style={loggedInStyle}>
                <div className="ScaleResizerClass">
                    {
                        loggedIn ? 
                            <div className={classes.toolbar} style={{ minHeight: 60+'px' }} />
                        :   ""
                    }
                    
                    <Switch>
                        {currentMenus.map((m, i) => {
                            return m.children ? (
                                m.children.map((a) => {
                                    return a.children ? (
                                        a.children.map((b) => {
                                            return <Route key={b.label} exact={b.exact} path={b.path} component={b.component}></Route>;
                                        })
                                    ) : (
                                        <Route key={a.label} exact={a.exact} path={a.path} component={a.component}></Route>
                                    );
                                })
                            ) : (
                                <Route key={m.label} exact={m.exact} path={m.path} component={m.component}></Route>
                            );
                        })}
                    </Switch>
                </div>
            </main>
        </div>
    );
}
